/* eslint-disable */
import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Box } from 'grommet';
import './styles/NavBar.css'

export const NavBar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const closeMenu = () => setMenuOpen(false);

    return (
        <div>
          <header>
            <Link to='/' className="nav-logo">
              <img src="/Picture3 - Transparent.png" alt="Bins Storage logo" className="logo-image"/>
            </Link>

            {/* Desktop nav links */}
            <div className="topnav">
              <Link to='/About'><Box pad={'small'}>About</Box></Link>
              <Link to='/FAQ'><Box pad={'small'}>FAQ</Box></Link>
              <Link to='/Contact'><Box pad={'small'}>Contact Us</Box></Link>
              <Link to='/Tenant'><Box pad={'small'}>Tenant Portal</Box></Link>
              <Link to='/Download'><Box background={'#261136'} round={'medium'} pad={"small"}>Reserve Now</Box></Link>
            </div>

            {/* Mobile: Reserve Now + hamburger icon (right side) */}
            <div className="mobile-right-group">
              <Link to='/Download' className="mobile-header-reserve">Reserve Now</Link>
              <button
                className="mobile-menu-btn"
                onClick={() => setMenuOpen(o => !o)}
                aria-label="Open menu"
              >
                <span className="hamburger-bar"></span>
                <span className="hamburger-bar"></span>
                <span className="hamburger-bar"></span>
              </button>
            </div>
          </header>

          {/* Mobile menu overlay */}
          {menuOpen && (
            <div className="mobile-menu-overlay" onClick={closeMenu}>
              <div className="mobile-menu-panel" onClick={e => e.stopPropagation()}>
                <div className="mobile-menu-header">
                  <Link to='/' onClick={closeMenu}>
                    <img src="/Picture3 - Transparent.png" alt="Bins Storage logo" className="mobile-menu-logo"/>
                  </Link>
                  <button className="mobile-menu-close" onClick={closeMenu} aria-label="Close menu">✕</button>
                </div>
                <div className="mobile-menu-links">
                  <Link to='/About' onClick={closeMenu} className="mobile-menu-link">About</Link>
                  <Link to='/FAQ' onClick={closeMenu} className="mobile-menu-link">FAQ</Link>
                  <Link to='/Contact' onClick={closeMenu} className="mobile-menu-link">Contact Us</Link>
                  <Link to='/Tenant' onClick={closeMenu} className="mobile-menu-link">Tenant Portal</Link>
                </div>
              </div>
            </div>
          )}
        </div>
    );
};
